import {View} from 'MWC';
import tpl from '../../templates/tablet/main';
import {list} from '../../list';
import React from 'react';

export default class extends View {
    constructor(props) {
        super(props);
        this.state = {
            subMenuAbout: list.subMenuAbout,
            subMenuCards: list.subMenuCards,
            subMenuCredit: list.subMenuCredit,
            subMenuBusiness: list.subMenuBusiness,
            subMenuServices: list.subMenuServices,
            subMenuDeposits: list.subMenuDeposits,

            subMenuCards2: list.subMenuCards2,
            subMenuCredit2: list.subMenuCredit2,
            subMenuDeposits2: list.subMenuDeposits2,
            subMenuBusiness2: list.subMenuBusiness2,
            subMenuServices2: list.subMenuServices2,
            subMenuServices3: list.subMenuServices3,
            subMenuBusiness3: list.subMenuBusiness3,
            cards: false,
            deposits: false,
            credit: false,
            business: false,
            services: false,
            isOpen: false,
            mode: 'cards'
        };

        this.toggleHover = this.toggleHover.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.toggleMode = this.toggleMode.bind(this);
        return this;
    }
    template = tpl;

    handleOutsideClick = event => {
        if (
            this.state.isOpen &&
            !event.target.closest('.tablet-header-menu-wrapper') &&
            !event.target.closest('.icon-menu__wrapper')
        ) {
            this.setState({isOpen: false});
        }
    };

    componentDidMount() {
        const activeTab = this.props.active;
        this.setState({mode: activeTab || 'cards'});
        document.addEventListener('click', this.handleOutsideClick);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
    }

    toggleMenu() {
        this.setState(prevState => ({isOpen: !prevState.isOpen}));
    }

    toggleMode(mode) {
        this.setState({mode: mode});
    }

    toggleHover(hover, name) {
        this.setState({[name]: hover});
    }

    static displayName = 'Header.Views.DesktopMain';
}
